import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundaryEditModalContainer, type BoundaryEditModalContainerProps,
} from './boundaryEditModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryEdit: BoundaryEditModalContainerProps;
  }
}
modalRenderer.register('BoundaryEdit', BoundaryEditModalContainer);
